import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFieldCustom(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M3 17a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1ZM21 17a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1ZM9.174 5.674c.95 0 1.762.338 2.437 1.013a3.323 3.323 0 0 1 1.013 2.437c0 .233-.017.442-.05.625a3.367 3.367 0 0 1-.15.55l5.4 5.425c.1.1.15.217.15.35 0 .133-.05.25-.15.35l-1.4 1.4c-.1.1-.217.15-.35.15a.48.48 0 0 1-.35-.15l-5.425-5.4a3.29 3.29 0 0 1-1.175.2c-.95 0-1.762-.338-2.437-1.013a3.323 3.323 0 0 1-1.013-2.437 3.537 3.537 0 0 1 .15-1.025.46.46 0 0 1 .35-.275.444.444 0 0 1 .425.125l1.85 1.85 1.4-1.4-1.85-1.85a.444.444 0 0 1-.125-.425.46.46 0 0 1 .275-.35c.167-.066.334-.108.5-.125.167-.016.342-.025.525-.025ZM6 2a1 1 0 0 1 0 2H4v2a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1h3ZM21 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V4h-2a1 1 0 1 1 0-2h3Z"
      />
    </BaseIcon>
  );
}
